import React from 'react';
import { useTranslation } from 'react-i18next';
import DesempenoIcon from '@panel/commons/assets/icons/desempeno-icon.svg';
import DesempenoIconLight from '@panel/commons/assets/icons/desempeno-greyLight.svg';
import { isSiteWithTelBanner } from '@panel/commons/helpers';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { SimpleButton } from '@panel/commons';
import { HeaderContainer } from './styles';
import Header from '../../Header';
import Dropdown from '../../Dropdown';
import DropdownBranches from '../../DropdownBranches';
import Calendario from '../../../assets/icons/calendario.svg';

const PageHeader = ({
  headerFilter,
  startFilter,
  endFilter,
  selectFilterList,
  updateFilter,
  isDesktop,
  device,
  insideHeader,
  title,
  likeDesktop,
  withTooltip,
  isStatisticsByPosting = false,
  onChangeViewPress,
  performanceDisabled,
  isGeneralStatistics = false,
  updateData,
  currentTab,
  branchSelected,
  setBranchSelected,
  branches
}) => {
  const { t } = useTranslation();

  return (
    <HeaderContainer
      isDesktop={isDesktop}
      isStatisticsByPosting={isStatisticsByPosting}
      device={device}
      portalWithBanner={isSiteWithTelBanner}
      isGeneralStatistics={isGeneralStatistics}
      currentTab={currentTab}
    >
      {(isDesktop || likeDesktop) && (
        <>
          <Header
            title={title || t('panel.estadisticas.header.title')}
            subtitle={device === 'mobile' ? null : t('panel.reputacion.scoring.date')}
            isDesktop={isDesktop}
            device={device}
            withTooltip={withTooltip}
            likeDesktop={likeDesktop}
            updateData={updateData}
          >
            {(currentTab === 'performance' || isStatisticsByPosting) && (
              <Dropdown
                width={isStatisticsByPosting && device === 'mobile' ? '330px' : '403px'}
                height={device === 'desktop' ? 'auto' : null}
                icon={Calendario}
                selectOptions={selectFilterList}
                currentFilter={headerFilter}
                startFilter={startFilter}
                endFilter={endFilter}
                callback={updateFilter}
                isDesktop={isDesktop}
                device={device}
                insideHeader={insideHeader}
                isStatisticsByPosting={isStatisticsByPosting}
                currentTab={currentTab}
              />
            )}
            {(currentTab === 'reputation' && branches && branches.length > 1) ||
              (currentTab === 'score' && branches && branches.length > 1 && (
                <DropdownBranches
                  width='328px'
                  device={device}
                  branchSelected={branchSelected}
                  setBranchSelected={setBranchSelected}
                  selectOptions={branches}
                />
              ))}
          </Header>
          {device === 'desktop' && !isGeneralStatistics && (
            <SimpleButton
              color={select(!performanceDisabled ? 'black' : 'midLightGray')}
              id='test-btn-3'
              borderColor={!performanceDisabled ? getColor('primary') : select('midLightGray')}
              backgroundColor={select(!performanceDisabled ? 'white' : 'lightGray')}
              height='40px'
              borderRadius='8px'
              backgroundColorHover={getColor('tertiary')}
              cursorDisabled={performanceDisabled}
              onClick={!performanceDisabled ? onChangeViewPress : null}
            >
              <img
                src={!performanceDisabled ? DesempenoIcon : DesempenoIconLight}
                alt='Ir a desempeno'
                data-panel='panel-button-icon-Desempeño_Estadisticas'
              />
              <div data-panel='panel-button-Desempeño_Estadisticas'>
                {t(`panel.estadisticas.posting.${!performanceDisabled ? 'toDesempeno' : 'withoutDesempeno'}.CTA`)}
              </div>
            </SimpleButton>
          )}
        </>
      )}

      {!isDesktop && !likeDesktop && currentTab === 'performance' && (
        <Dropdown
          width='100%'
          height='48px'
          icon={Calendario}
          selectOptions={selectFilterList}
          currentFilter={headerFilter}
          startFilter={startFilter}
          endFilter={endFilter}
          callback={updateFilter}
          device={device}
          currentTab={currentTab}
        />
      )}
    </HeaderContainer>
  );
};

export default PageHeader;
